export const IMAGE_IDS = {
  HERO_IMAGE: 'Hero Image',
  HERO_LOGO: 'Hero Logo',
  LINE_ITEM: 'Line Item',
};
